import axios from 'axios';
import { showLoader, toggleAlertMessage } from '../action';
import createSignedRequest from './createSignedRequest';
import { v4 as uuidv4 } from 'uuid';
import { format, subYears, parseISO, addDays } from 'date-fns';
import { getReportingYearDates, getMultiYearChartDates } from '../../components/Common/ReusableComponents/Reusable';
const { apiURL } = require('./apiURL');

const Types = {
  SAVE_COMPONENT: 'DASHBOARD_SAVE_COMPONENT',
  REMOVE_COMPONENT: 'DASHBOARD_REMOVE_COMPONENT',
  EDIT_COMPONENT: 'DASHBOARD_EDIT_COMPONENT',
  SAVE_SUM: 'DASHBOARD_SAVE_SUM',
  GET_TARGETS: 'DASHBOARD_GET_TARGETS',
  GET_COMPONENTS: 'DASHBOARD_GET_COMPONENTS',
};

const saveSum = (sum) => ({
  type: Types.SAVE_SUM,
  payload: sum,
});

const dashboardDataCache = new Map();

const sumValues = (component, year, org, dataType = 'market', ignoreCache = false) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    const url = `${apiURL}/my/dashboard/data`;

    let data;
    function generateKey(year, org, dataType) {
      return `${org}_${year}_${dataType}`;
    }

    try {
      console.log('cache:', dashboardDataCache);
      if (dashboardDataCache.has(generateKey(year, org, dataType)) && ignoreCache === false) {
        data = dashboardDataCache.get(generateKey(year, org, dataType));

        dispatch(saveSum(data));
        dispatch(showLoader(false));
      } else {
        const response = await axios(
          await createSignedRequest('POST', url, JSON.stringify(component), {
            Organisation: String(state.currentOrganisation),
          })
        );

        data = response?.data;

        if (response?.data) {
          dashboardDataCache.set(generateKey(year, org, dataType), data);
        }

        dispatch(saveSum(data));
        dispatch(showLoader(false));
      }

      return data;
    } catch (error) {
      dispatch(showLoader(false));
      dispatch(toggleAlertMessage(true, 'Error fetching data', 'Error'));
    }
  };
};

const storeTargets = (targets) => ({
  type: 'DASHBOARD_GET_TARGETS',
  payload: targets,
});

const getTargets = () => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    const url = `${apiURL}/my/organisation/targets`;

    try {
      const response = await axios(
        await createSignedRequest('GET', url, null, {
          Organisation: String(state.currentOrganisation),
        })
      );

      dispatch(storeTargets(response?.data));
      dispatch(showLoader(false));
    } catch (error) {
      dispatch(showLoader(false));
      dispatch(toggleAlertMessage(true, 'Error fetching data', 'Error'));
    }
  };
};

const saveTargets = (targets) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest('POST', apiURL + `/my/organisation/targets`, JSON.stringify({ targets }), {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('saveTargets', response);
      const { updatedTargets, message } = response?.data;
      if (updatedTargets?.success == true) {
        dispatch(showLoader(false));
        dispatch(toggleAlertMessage(true, message, 'success'));
        dispatch(getTargets());
      } else {
        showLoader(false);
        dispatch(toggleAlertMessage(true, message, 'error'));
      }
    } catch (e) {
      console.log('saveTargets Error:', e);
    }
  };
};

const deleteTarget = (targetId) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    try {
      const response = await axios(
        await createSignedRequest('DELETE', `${apiURL}/my/organisation/targets/${targetId}`, '{}', {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('deleteTarget response:', response);
      if (response?.data?.success) {
        dispatch(toggleAlertMessage(true, response?.data?.message, 'success'));
        dispatch(getTargets());
      }
    } catch (error) {
      console.error('Error deleting target:', error);
      dispatch(toggleAlertMessage(true, 'Error deleting target', 'error'));
    } finally {
      dispatch(showLoader(false));
    }
  };
};

const fetchComponents = (components) => ({
  type: Types.GET_COMPONENTS,
  payload: components,
});

const getDashboardComponents = () => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    const url = `${apiURL}/my/dashboard/components`;

    try {
      const response = await axios(
        await createSignedRequest('GET', url, null, {
          Organisation: String(state.currentOrganisation),
        })
      );

      console.log('response:', response);
      dispatch(fetchComponents(response?.data));
      dispatch(showLoader(false));
    } catch (error) {
      dispatch(showLoader(false));
      dispatch(toggleAlertMessage(true, 'Error Fetching Dashboard Data', 'Error'));
    }
  };
};

const saveComponent = (component) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    const url = `${apiURL}/my/dashboard/component`;

    let componentData = { ...component, id: uuidv4() };

    try {
      const response = await axios(
        await createSignedRequest('POST', url, JSON.stringify(componentData), {
          Organisation: String(state.currentOrganisation),
        })
      );

      dispatch(getDashboardComponents());
      dispatch(toggleAlertMessage(true, response?.data?.message, 'success'));
    } catch (error) {
      dispatch(toggleAlertMessage(true, 'Error Saving Dashboard Data', 'Error'));
    }
  };
};

const editComponent = (component) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    const url = `${apiURL}/my/dashboard/component/${component.id}`;

    try {
      const response = await axios(
        await createSignedRequest('PUT', url, JSON.stringify(component), {
          Organisation: String(state.currentOrganisation),
        })
      );

      dispatch(toggleAlertMessage(true, response?.data?.message, 'success'));
      dispatch(getDashboardComponents());
    } catch (error) {
      dispatch(toggleAlertMessage(true, 'Error Saving Dashboard Data', 'Error'));
    }
  };
};

const deleteComponent = (componentId) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader(true));

    const url = `${apiURL}/my/dashboard/component/${componentId}`;

    try {
      const response = await axios(
        await createSignedRequest('DELETE', url, '{}', {
          Organisation: String(state.currentOrganisation),
        })
      );

      dispatch(toggleAlertMessage(true, response?.data?.message, 'success'));
      dispatch(getDashboardComponents());
    } catch (error) {
      dispatch(toggleAlertMessage(true, 'Error Deleting Dashboard Data', 'Error'));
    }
  };
};

const saveComponents = (components) => {
  return async (dispatch, getState) => {
    const state = getState();

    const url = `${apiURL}/my/dashboard/components`;

    try {
      const response = await axios(
        await createSignedRequest('POST', url, JSON.stringify(components), {
          Organisation: String(state.currentOrganisation),
        })
      );
    } catch (error) {
      dispatch(toggleAlertMessage(true, 'Error Saving Dashboard Components', 'Error'));
    }
  };
};

const Actions = {
  saveComponent,
  editComponent,
  saveSum,
  sumValues,
  getTargets,
  saveTargets,
  deleteTarget,
  getDashboardComponents,
  deleteComponent,
  saveComponents,
};

export { Actions, Types };
